import { render } from "./FeedbackboardPhoneticTranscription.vue?vue&type=template&id=5bd04b6e&scoped=true"
import script from "./FeedbackboardPhoneticTranscription.vue?vue&type=script&lang=js"
export * from "./FeedbackboardPhoneticTranscription.vue?vue&type=script&lang=js"

import "@/css/components/feedbackboard-phonetic-transcription.css?vue&type=style&index=0&id=5bd04b6e&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bd04b6e"]])

export default __exports__